import Vue from 'vue';

import './changeset';
import './fuel';
import './measurement';
import './override_pricebook';
import './pricebook';
import './station_changeset';
import './tank';

/** Franchise Inventory Tag Vue Element*/
Vue.component('vuetable_tag', () =>
    import(/* webpackChunkName: 'inventory' */ './tag/vuetable_tag.vue'),
);

Vue.component('vuetabletag_form', () =>
    import(/* webpackChunkName: 'inventory' */ './tag/vuetabletag_form.vue'),
);

Vue.component('multi_layer_section', () =>
    import(/* webpackChunkName: 'inventory' */ './tag/multi_layer_section.vue'),
);

Vue.component('product_list', () =>
    import(/* webpackChunkName: 'inventory' */ './tag/product_list.vue'),
);

/** Franchise Inventory items Vue Element*/
Vue.component('vuetable_item', () =>
    import(/* webpackChunkName: 'inventory' */ './item/vuetable_item.vue'),
);

Vue.component('vuetableitem_form', () =>
    import(/* webpackChunkName: 'inventory' */ './item/vuetableitem_form.vue'),
);

Vue.component('color_picker', () =>
    import(/* webpackChunkName: 'inventory' */ './item/colorPicker.vue'),
);

Vue.component('category-list', () =>
    import(/* webpackChunkName: 'inventory' */ './category/category-list.vue'),
);

/** Franchise Inventory coupons Vue Element*/
Vue.component('coupon-master', () =>
    import(/* webpackChunkName: 'inventory' */ './coupon/coupon-master.vue'),
);

Vue.component('vuetable_coupon', () =>
    import(/* webpackChunkName: 'inventory' */ './coupon/vuetable_coupon.vue'),
);

Vue.component('vuetablecoupon_form', () =>
    import(/* webpackChunkName: 'inventory' */ './coupon/vuetablecoupon_form.vue'),
);

/** Franchise Inventory Taxes Vue Element*/
Vue.component('vuetable-tax', () =>
    import(/* webpackChunkName: 'inventory' */ './tax/vuetable_tax.vue'),
);

Vue.component('vuetable-charge', () =>
    import(/* webpackChunkName: 'inventory' */ './charge/vuetable_charge.vue'),
);
